<div data-clarity-mask="true">
  <div class="row pt-4 pb-4">
    <div class="col-10 col-md-12">
      <form [formGroup]="searchForm">
        <label class="d-none sr-only" for="searchInput">{{ translationKey() + '.search-placeholder' | translate }}</label>
        <myarvato-searchbar
          [formControl]="searchInputControl"
          [maxlength]="maxSearchLength()"
          [placeholder]="translationKey() + '.search-placeholder' | translate"
        ></myarvato-searchbar>
      </form>
    </div>
    <div class="col-2 d-block d-md-none">
      <p-button icon="pi pi-times" (onClick)="close()" [rounded]="true" variant="text" />
    </div>
  </div>

  @if (loading()) {
    <div class="d-block vertical-line spinner">
      <i class="pi pi-spinner spinner--icon"></i>
    </div>
  } @else if (!hasResults()) {
    @if (errorMessage()) {
      <myarvato-error-message [summary]="errorMessage()" [details]="''" class="mb-3"></myarvato-error-message>
    }
    <span class="d-block vertical-line"> {{ translationKey() + '.empty' | translate }}</span>
  } @else if (hasResults()) {
    <div class="row header">{{ translationKey() + '.title' | translate }}</div>
    <div class="row pt-3">
      <div class="result-list">
        <!-- HRN-1592: Complex button - manual conversion needed -->
        @for (item of results(); track $index) {
          <button
            (click)="mouseClick(item)"
            [class.selected-row]="item === selected()"
            class="d-flex list-group-item list-group-item-action result-list-group"
          >
            <div class="icon align-self-center">
              <em class="pi pi-shopping-bag"></em>
            </div>
            <div class="order-content">
              <div class="order-header">
                {{ translationKey() + '.data-field.' + item.searchKey | translate }}
              </div>
              <div [innerHTML]="item.highlightedValue" class="order-key"></div>
              <div class="order-info">
                <ng-container [ngTemplateOutlet]="rowTemplate()" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
              </div>
            </div>
            <div class="icon align-self-center">
              <em class="pi pi-reply rotate-180"></em>
            </div>
          </button>
        }
      </div>
    </div>
  }

  <div class="d-block d-md-none mb--32"></div>

  <div class="d-none d-md-block border-md-top">
    <div class="pt--16 d-flex flex-row">
      <div class="d-flex flex-row align-items-center mr--8">
        <em class="pi pi-reply rotate-180 font-size-12"></em
        ><span class="font-size-12"> {{ translationKey() + '.footer.to-select' | translate }}</span>
      </div>
      <div class="d-flex flex-row align-items-center mr--8">
        <em class="pi pi-sort-alt font-size-12"></em>
        <span class="font-size-12"> {{ translationKey() + '.footer.to-navigate' | translate }}</span>
      </div>
      <div class="d-flex flex-row align-items-center">
        <span class="small-rounded">esc</span><span class="font-size-12"> {{ translationKey() + '.footer.to-close' | translate }}</span>
      </div>
    </div>
  </div>
</div>
